import dayjs from 'dayjs';
import { ProjectTaskFragmentFragment } from 'gql/index';
import { useIntl } from 'react-intl';

export const useTaskFormatters = () => {
  const { formatMessage } = useIntl();

  const formatDueDate = (dueDate: string) => {
    const daysDiffWithDueDate = dayjs(dueDate).startOf('day').diff(dayjs().startOf('day'), 'days');

    return daysDiffWithDueDate === 0 ? formatMessage({ id: 'Due today' })
      : dayjs(dueDate).isAfter(dayjs())
        ? formatMessage({ id: 'Due in {daysDiffWithDueDate}' }, { daysDiffWithDueDate: dayjs.duration({ days: daysDiffWithDueDate }).humanize() })
        : formatMessage({ id: 'Due {daysDiffWithDueDate}' }, { daysDiffWithDueDate: dayjs.duration({ days: daysDiffWithDueDate }).humanize(true) });
  };

  const formatTaskSecondaryText = (task: ProjectTaskFragmentFragment) => {
    const date = task.dueDate ?? task.startDate;
    const dateText = date ? formatDueDate(date) : '';

    if (task.project?.name) {
      return dateText ? `${dateText} • ${task.project?.name}` : task.project?.name;
    }

    return dateText;
  };

  return { formatDueDate, formatTaskSecondaryText };
};

